import { useEffect, useRef, useState } from "react";
import { IProduct, InicialValues, onChangeArgs } from "../interfaces/interfaces";

interface useProductArgs {
    product: IProduct;
    onChange?: (arg: onChangeArgs) => void;
    value?: number;
    initialValues?: InicialValues;
}

export const useProduct = ({ onChange, product, value = 0, initialValues }: useProductArgs) => {
    const [counter, setCounter] = useState<number>(initialValues?.count || value);
    const isMounted = useRef(false);

    const increaseBy = (value: number) => {
        //if (!!initialValues?.maxCount && counter === initialValues.maxCount) return;
        let newValue = Math.max(counter + value, 0);

        if (initialValues?.maxCount) newValue = Math.min(newValue, initialValues.maxCount);

        setCounter(newValue);

        onChange && onChange({ count: newValue, product });
    };

    const reset = () => {
        setCounter(initialValues?.count || value);
    };

    useEffect(() => {
        if (!isMounted.current) return;
        setCounter(initialValues?.count || value);
    }, [value]);

    useEffect(() => {
        isMounted.current = true;
    }, []);

    return {
        counter,
        isMaxCountReached: !!initialValues?.count && initialValues.maxCount === counter,
        maxCount: initialValues?.maxCount,
        increaseBy,
        reset,
    };
};
